import React from 'react'

const ViewProcurementRequest = () => {
  return (
    <div className='mx-auto p-4'>
      <h4 className='font-semibold my-4'>Procurement <span className='text-[#0E6F1E]'>> Request</span></h4>

      <div className="bg-white p-4 rounded-lg">
        <h4 className='font-bold text-[#2670de]'>New</h4>
        <div>
          
        </div>
      </div>
    </div>
  )
}

export default ViewProcurementRequest
